import React, { type ReactNode, createContext, useContext, useState } from 'react';

interface CardOpenContextType {
	openCards: Set<number>;
	setOpenCards: React.Dispatch<React.SetStateAction<Set<number>>>;
}
const CardOpenContext = createContext<CardOpenContextType>({
	openCards: new Set(),
	setOpenCards: () => null,
});

export const CardOpenProvider = ({ children }: { children: ReactNode }) => {
	const [openCards, setOpenCards] = useState(new Set<number>([]));
	return (
		<CardOpenContext.Provider value={{ openCards, setOpenCards }}>
			{children}
		</CardOpenContext.Provider>
	);
};

export const useOpenCardContext = () => useContext(CardOpenContext);

export const useCardOpen = (id: number) => {
	const { openCards, setOpenCards } = useContext(CardOpenContext);

	return {
		isContentExpanded: openCards.has(id),
		toggleOpen: () => {
			openCards.has(id) ? openCards.delete(id) : openCards.add(id);
			setOpenCards(new Set(openCards));
		},
	};
};
